import { isBaseQueryParams } from "@/helpers/isBaseQueryParams";
import { QueryParamsBase } from "@/types/types";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { getClientPurchases, getClients } from "./api";

const STALE_TIME_BASE = 1000 * 60 * 10; // 10 minutos

export function useClients(
  params?: QueryParamsBase,
  select?: string[],
  options?: object,
) {
  const isBaseQuery = isBaseQueryParams(params);

  const paramsQuery = isBaseQuery
    ? { current: params?.current, pageSize: params?.pagination?.pageSize }
    : params;

  const query = useQuery({
    queryKey: ["clients", { params: paramsQuery, select }],
    queryFn: () => getClients({ ...paramsQuery, select }),
    staleTime: isBaseQuery ? STALE_TIME_BASE : 0,
    gcTime: isBaseQuery ? STALE_TIME_BASE : 0,
    placeholderData: keepPreviousData,
    ...options,
  });

  return { ...query };
}

export function useClientPurchases(
  customer_id: string,
  params?: QueryParamsBase,
  select?: string[],
  options?: object,
) {
  const isBaseQuery = isBaseQueryParams(params);

  const paramsQuery = isBaseQuery
    ? { current: params?.current, pageSize: params?.pagination?.pageSize }
    : params;

  const query = useQuery({
    queryKey: [
      "client-purchases",
      customer_id,
      { params: paramsQuery, select },
    ],
    queryFn: () => getClientPurchases(customer_id, { ...paramsQuery, select }),
    staleTime: isBaseQuery ? STALE_TIME_BASE : 0,
    gcTime: isBaseQuery ? STALE_TIME_BASE : 0,
    placeholderData: keepPreviousData,
    enabled: !!customer_id,
    ...options,
  });

  return { ...query };
}
